import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { ReactComponent as ArrowDownSVG } from "assets/img/ArrowDown.svg";

import Documents from "components/OrderDetail/Documents";
import OrderStatusMobile from "components/OrderDetail/OrderStatusMobile";
import TrademarkClassificationsMobile from "components/OrderDetail/TrademarkClassificationsMobile";
import TrademarkOwnersMobile from "components/OrderDetail/TrademarkOwnersMobile";
import TrademarkRegisterDetails from "components/OrderDetail/Products/TrademarkRegisterDetails";

import breakpoints from "_constants/breakpoints";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 48px 20px;

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 32px 0px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 0;
  opacity: 0;
  transform: scaleY(0);
  transform-origin: 0 0;
  transition: 0.5s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      height: 100%;
      opacity: 1;
      transform: scaleY(1);
    `}
`;
const SectionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #ffffff;
  border: 1px solid #a5aaaf;
  box-sizing: border-box;
  padding: 8px 15px 8px 20px;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 36px;
  text-align: left;
  color: #03589c;
  transform-origin: 0 0;
  transition: 0.5s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      margin-bottom: 24px;
    `}

  @media (max-width: ${breakpoints.mobileM}) {
    width: 90%;
  }
`;

function OrderDetailsMobile({
  orderId,
  orderDetails,
  productsFiles,
  registerDetails,
  logoDesignServiceDetails,
  hasSearch,
  hasMonitoring,
  classes,
  individual,
  coOwners,
  organization,
  notes,
  assessments,
}) {
  const [isOpenDetails, setOpenDetails] = useState(false);
  const [isOpenDocuments, setOpenDocuments] = useState(false);
  const [isOpenStatus, setOpenStatus] = useState(false);

  return (
    <Container>
      <SectionButton id="order-details" isOpen={isOpenDetails} onClick={() => setOpenDetails(!isOpenDetails)}>
        Order Details
        <ArrowDownSVG fill="#F37217" transform={isOpenDetails ? "rotate(180)" : undefined} />
      </SectionButton>
      <Content isOpen={isOpenDetails}>
        <TrademarkRegisterDetails registerDetails={registerDetails} />
        <TrademarkClassificationsMobile classes={classes} />
        <TrademarkOwnersMobile coOwners={coOwners} individual={individual} organization={organization} />
      </Content>

      {logoDesignServiceDetails ? (
        <>
          <SectionButton
            id="documents-details"
            isOpen={isOpenDocuments}
            onClick={() => {
              setOpenDocuments(!isOpenDocuments);
            }}
          >
            Logo Designs
            <ArrowDownSVG fill="#F37217" transform={isOpenDocuments ? "rotate(180)" : undefined} />
          </SectionButton>
          <Content isOpen={isOpenDocuments}>
            <Documents
              orderId={orderId}
              files={[...productsFiles]}
              emptyMessage="No Logo Designs Uploaded Yet."
              actions="LOGO_DESIGN_SERVICE"
            />
          </Content>
        </>
      ) : (
        <>
          <SectionButton
            id="documents-details"
            isOpen={isOpenDocuments}
            onClick={() => {
              setOpenDocuments(!isOpenDocuments);
            }}
          >
            Documents
            <ArrowDownSVG fill="#F37217" transform={isOpenDocuments ? "rotate(180)" : undefined} />
          </SectionButton>
          <Content isOpen={isOpenDocuments}>
            <Documents orderId={orderId} files={[...orderDetails.files, ...productsFiles]} assessments={assessments} />
          </Content>
        </>
      )}

      <SectionButton
        id="status-details"
        isOpen={isOpenStatus}
        onClick={() => {
          setOpenStatus(!isOpenStatus);
        }}
      >
        Order Status
        <ArrowDownSVG fill="#F37217" transform={isOpenStatus ? "rotate(180)" : undefined} />
      </SectionButton>
      <Content isOpen={isOpenStatus}>
        <OrderStatusMobile
          orderId={orderId}
          specimen={!!registerDetails}
          search={!!hasSearch}
          monitoring={hasMonitoring}
          notes={notes}
        />
      </Content>
    </Container>
  );
}

OrderDetailsMobile.propTypes = {
  orderId: PropTypes.string,
  orderDetails: PropTypes.object,
  registerDetails: PropTypes.object,
  logoDesignServiceDetails: PropTypes.object,
  hasSearch: PropTypes.bool,
  hasMonitoring: PropTypes.bool,
  individual: PropTypes.object,
  organization: PropTypes.object,
  assessments: PropTypes.object,
  classes: PropTypes.arrayOf(PropTypes.object),
  coOwners: PropTypes.arrayOf(PropTypes.object),
  productsFiles: PropTypes.arrayOf(PropTypes.object),
  notes: PropTypes.arrayOf(PropTypes.object),
};

export default OrderDetailsMobile;
